// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IChatUserSchema {
  /** Название компании. На Android НЕ используется. **/
  agencyName?: string;
  /** Тип пользователя. На Android НЕ используется. **/
  agentAccountType?: EAgentAccountType;
  /**
   *
   *         Ссылка на аватарку. Используется в списке чатов на месте фото в случае,
   *         если чат инициирован с агентом, а не по объявлению.
   *
   */
  agentAvatarUrl?: string;
  /** Роль пользователя в чате, в котором он передан **/
  chatRole: EChatRole;
  /**
   *
   *         Пользователь имеет опубликованный профиль в каталоге специалистов.
   *         Флаг нужен для понимания того, возможен ли переход к просмотру профиля.
   *         Поле можно будет удалить после переезда на профиль собеседника в чате.
   *         Переход в профиль из каталога будет осуществляться оттуда.
   *
   */
  hasPublicProfile: boolean;
  /** Доступен ли пользователь для звонка. Раньше поле находилось в data.agent структуре **/
  isAvailableForPhoneCall: boolean;
  /**
   *
   *         Имя пользователя в соответствии с требованиями бизнеса.
   *         Если отсутствует, то клиенты отображают Идентификатор пользователя по своей логике.
   *
   */
  name?: string;
  /** Ссылка на изображение, которая должна использоваться вместо имени пользователя на клиентах **/
  nameReplacementImageUrl?: string;
  /** Телефоны для контакта с пользователем, в формате 79133451133 **/
  phones?: string[];
  /** Абсолютный URL на публичный профиль агента **/
  urlToAgentPublicProfile?: string;
  /** Идентификатор пользователя (realty_user_id) **/
  userId: number;
}

export enum EAgentAccountType {
  /** Специалист **/
  'Agency' = 'agency',
  /** Застройщик **/
  'Developer' = 'developer',
  /** Собственник **/
  'Homeowner' = 'homeowner',
  /** Управляющая компания **/
  'Management_company' = 'management_company',
  /** Отдел аренды **/
  'Rent_department' = 'rent_department',
  /** Поискун **/
  'Searcher' = 'searcher',
  /** Риэлтор **/
  'Specialist' = 'specialist',
  /** Системные сообщения от администрации ЦИАН-а **/
  'System' = 'system',
}
export enum EChatRole {
  /**
   *
   *     Все остальные возможные участники чата (в том числе чат-боты)
   *
   */
  'Companion' = 'companion',
  /**
   *
   *     Клиент, который проявил интерес к бизнес-предложению (откликнулся по объявлению, оставил заявку)
   *
   */
  'Initiator' = 'initiator',
  /**
   *
   *     В случае агентств недвижимости — руководитель opponent (может добавиться в чат, где уже есть initiator и opponent)
   *
   */
  'Master' = 'master',
  /**
   *
   *     Тот, кто реагирует на интерес initiator (публикует объявление, получает заявку)
   *
   */
  'Opponent' = 'opponent',
}
